/**
 *
 * @param logo tell the logo of the unit fetched from linkkipalvelu
 * @returns image alt text of logo and path of logo
 */
import sydanSairaalaLogoSrc from '../images/sydansairaala-logo.svg';
import controlPanelLogo from '../images/control-panel-logo.png';
import coxaLogo from '../images/coxa-logo.png';

export const getLogo = (logo) => {
  switch (logo) {
    case 'SYDAN':
      return {
        altTextId: `alt.text.${logo.toLowerCase()}`,
        logoSrc: sydanSairaalaLogoSrc,
      };
    case 'TAYS':
      return {
        altTextId: `alt.text.${logo.toLowerCase()}`,
        logoSrc: controlPanelLogo,
      };
    case 'COXA':
      return {
        altTextId: `alt.text.${logo.toLowerCase()}`,
        logoSrc: coxaLogo,
      };
    default:
      return null;
  }
};
